import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchCompanyProfile } from '@/api/companies';
import { CustomInformationTab } from '@/app/(client)/network/-components/companyProfileTabs/customInformation/CustomInformationTab';
import { queryClient } from '@/lib/utils/queryClient';
import { useSessionStore } from '@/store/sessionStore';

function isFeatureEnabled(
  features: Array<{ id: string }> | undefined,
  id: string,
): boolean {
  return features?.some(f => f.id === id) ?? false;
}

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/custom-information',
)({
  beforeLoad: async ({ params }) => {
    const company = await queryClient.ensureQueryData({
      queryKey: ['network', 'company', params.companyId],
      queryFn: () => fetchCompanyProfile(params.companyId),
    });
    const user = useSessionStore.getState().user;
    const isOwnCompany =
      user?.companyId === (company?.forCompanyId ?? params.companyId);
    const allowed =
      isFeatureEnabled(
        user?.company?.enabledFeatures,
        'custom-information-fields',
      ) && !isOwnCompany;
    if (!allowed) {
      throw redirect({
        to: '/network/$companyId/general-info',
        params: { companyId: params.companyId },
      });
    }
  },
  component: CustomInformationRoute,
});

function CustomInformationRoute() {
  const { companyId } = Route.useParams();
  return <CustomInformationTab companyId={companyId} />;
}
